import { Button } from "react-bootstrap"

export const AddReviewButton: React.FC<{onClick: () => void}> = ({ onClick }) => {
    return (
        <Button
            key="add-review-assignment-btn"
            className="ms-2"
            onClick={onClick}
            variant="theme">
                <i className="fas fa-plus pe-2" />
                <span className="d-none d-md-inline">Assign Core Ideas</span>
        </Button>
    )
}
